import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/auth/Login'
import App from '../components/App'
import store from '../store' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      requiresVisitor: true,
    }
  },
  {
    path: '/app',
    name: 'App',
    component: App,
    meta: {
      requiresAuth: true
    }
  },  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // console.log("Authenticated: ", store.getters['auth/authenticated']);
    if (!store.getters['auth/getAuthenticated']) {
      next({
        path: '/',
        
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters['auth/getAuthenticated']) {
      next({
        path: '/app',
        
      })
    } else {
      next()
    }
  }else {
    next() // make sure to always call next()!
  }
})

export default router
